// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api.dev.skycash.com/api/skycash/parkingi-panel',
  keycloakConfig: {
    clientId: 'user-panel',
    realm: 'TestProviders',
    url: 'https://im.test.skycash.com/auth',
  },
  canManageRoles: 'skycash:service:provider-panel:manage-user'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
